import { render, staticRenderFns } from "./ex.vue?vue&type=template&id=31d4a886&scoped=true"
import script from "./ex.vue?vue&type=script&lang=js"
export * from "./ex.vue?vue&type=script&lang=js"
import style0 from "./ex.vue?vue&type=style&index=0&id=31d4a886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d4a886",
  null
  
)

export default component.exports